/**
 * Phase 26.9.2 — Category → color mapping for the event cover placeholder.
 *
 * Frontend mirror of /app/backend/services/event_category_theme.py.
 * Keep the two in sync when adding new categories.
 */

const CATEGORY_THEMES = {
  training:      { from: '#0a2050', to: '#14396d', accent: '#f5c876', label: 'Training' },
  certification: { from: '#064e3b', to: '#0f766e', accent: '#a7f3d0', label: 'Certification' },
  networking:    { from: '#4c1d95', to: '#6d28d9', accent: '#f5d0fe', label: 'Networking' },
  conference:    { from: '#7c2d12', to: '#c2410c', accent: '#fed7aa', label: 'Conference' },
  webinar:       { from: '#0e7490', to: '#0891b2', accent: '#a5f3fc', label: 'Webinar' },
  meeting:       { from: '#334155', to: '#475569', accent: '#e2e8f0', label: 'Meeting' },
  workshop:      { from: '#831843', to: '#be185d', accent: '#fbcfe8', label: 'Workshop' },
  recruiting:    { from: '#1e3a8a', to: '#2563eb', accent: '#bfdbfe', label: 'Recruiting' },
  town_hall:     { from: '#3f3f46', to: '#71717a', accent: '#e4e4e7', label: 'Town Hall' },
  announcement:  { from: '#78350f', to: '#b45309', accent: '#fde68a', label: 'Announcement' },
};

const DEFAULT_THEME = { from: '#0a2050', to: '#14396d', accent: '#f5c876', label: 'Event' };

export function themeForCategory(category) {
  if (!category) return DEFAULT_THEME;
  return CATEGORY_THEMES[String(category).toLowerCase()] || DEFAULT_THEME;
}

export { CATEGORY_THEMES, DEFAULT_THEME };
